<template>
    <el-container>
      <el-header>
      <!-- 视频背景 -->
      <div class="video-background">
<!--        <video autoplay loop muted>-->
<!--          <source src="../assets/bg.mp4" type="video/mp4" />-->
<!--        </video>-->
        <img src="../assets/dna.png"  />
      </div>

      <!-- 导航栏 -->
      <div class="navbar">
        <el-menu mode="horizontal" :default-active="activeLink" @select="handleNavSelect">
          <el-menu-item index="1">Home</el-menu-item>
          <el-menu-item index="2">Search</el-menu-item>
          <el-menu-item index="3">About</el-menu-item>
        </el-menu>
      </div>

      <div class="header-title">
        <h1>ModVAR</h1>
      </div>
      <div class="header-subtitle">
        Cancer Driver Variant Functional Prediction
      </div>

      <el-form inline style="display: flex;" class="search-container" :class="{ 'show-search': activeLink === '2' }">
        <!-- Search method -->
        <el-form-item v-if="activeLink === '2'">
          <el-select v-model="filters.method" placeholder="Search method" @change="handleSearchMethodChange">
              <el-option v-for="option in methodOptions" :key="option" :label="option" :value="option"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="filters.method === 'Search by hg38 position' || filters.method === 'Search by hg19 position'">
          <!-- Chromosome dropdown -->
          <el-form-item class='chr'>
            <el-select v-model="filters.chr" placeholder="Select Chromosome">
              <el-option v-for="option in chrOptions" :key="option" :label="option" :value="option"></el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-if="filters.method === 'Search by hg19 position'">
          <el-form-item>
            <el-input v-model="filters.posHg19" placeholder="Enter hg19 position">
                <template #append>
                    <el-dropdown trigger="click">
                        <el-button class="filter-button" style="width: 10px; display: flex; justify-content: center;">
                            <i class="el-icon-arrow-down"></i>
                        </el-button>
                        <el-dropdown-menu>
                            <el-dropdown-item @click.native="setOperator19('gt')">></el-dropdown-item>
                            <el-dropdown-item @click.native="setOperator19('eq')">=</el-dropdown-item>
                            <el-dropdown-item @click.native="setOperator19('lt')"><</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                  </template>
              </el-input>
          </el-form-item>
        </template>

        <template v-if="filters.method === 'Search by hg38 position'">
          <el-form-item>
            <el-input v-model="filters.posHg38" placeholder="Enter hg38 position">
                <template #append>
                    <el-dropdown trigger="click">
                        <el-button class="filter-button" style="width: 10px; display: flex; justify-content: center;">
                            <i class="el-icon-arrow-down"></i>
                        </el-button>
                        <el-dropdown-menu>
                            <el-dropdown-item @click.native="setOperator38('gt')">大于</el-dropdown-item>
                            <el-dropdown-item @click.native="setOperator38('eq')">等于</el-dropdown-item>
                            <el-dropdown-item @click.native="setOperator38('lt')">小于</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                  </template>
              </el-input>
          </el-form-item>
        </template>

        <template v-if="filters.method === 'Search by hg38 position' || filters.method === 'Search by hg19 position'">
          <!-- Reference Allele dropdown -->
          <el-form-item>
              <el-select v-model="filters.ref" placeholder="Select Ref Allele">
                  <el-option v-for="allele in alleleOptions" :key="allele" :label="allele" :value="allele"></el-option>
              </el-select>
          </el-form-item>

          <!-- Alternative Allele dropdown -->
          <el-form-item>
              <el-select v-model="filters.alt" placeholder="Select Alt Allele">
                  <el-option v-for="allele in alleleOptions" :key="allele" :label="allele" :value="allele"></el-option>
              </el-select>
          </el-form-item>
        </template>


        <!-- Search button -->
        <el-form-item :style="{ marginLeft: '0px',width:'50px' }" class="search" v-if="activeLink === '2'">
          <el-button type="primary" @click="fetchData"> Search </el-button>
        </el-form-item>


      </el-form>
    </el-header>


    <el-main>
      <!-- Home Content -->
      <div v-if="activeLink === '1'">

        <el-row :gutter="20">
          <el-col :span="15">  
            <div class="block">
                <el-carousel :autoplay="false">
                  <el-carousel-item v-for="item in images" :key="item.id">
                    <el-image :src="item.src" fit="cover" alt="carousel image"></el-image>
                  </el-carousel-item>
                </el-carousel>
            </div>
          </el-col>

          <el-col :span="9" style="margin-top:24px">
            <div class="enhanced-text" style="text-align: left;padding:25px">
            <p>
              ModVAR is an innovative multimodal model that integrates DNA sequences, protein tertiary structures, and cancer omics data to predict driver variants with exceptional precision.            <p>
              Users can explore ModVAR's predictions using the following search methods:
            </p>
            <ul style="line-height: 1.5;">
              <li style="margin-bottom: 15px;"><strong>Search by hg19 Mutation Position:</strong> Query mutations using hg19 genomic coordinates.</li>
              <li style="margin-bottom: 15px;"><strong>Search by hg38 Mutation Position:</strong> Query mutations using hg38 genomic coordinates.</li>
              <li style="margin-bottom: 15px;"><strong>Search by File Upload:</strong> Upload a TSV file (maximum size: 500KB) for batch analysis. The file must include the following columns with identical headers: Chromosome, PositionHg19, ReferenceAllele, and AlternativeAllele.</li>
            </ul>
            <p>
              Start exploring ModVAR now !
            </p>
            </div>
          </el-col>
        </el-row>


      </div>

      <!-- Search Content -->
      <div v-if="activeLink === '2'">
        <el-row :gutter="20">
          <template v-if="filters.method === 'Search by file'">
          <el-col :span="4"> 
            <div class="upload_contrainer">
              <div class="search-title">Search by File</div>

              <el-upload
                drag
                :http-request="handleFileUpload"
                :before-upload="beforeUpload"
                :disabled="loading"
                action=""
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">Drag your file here<br>or<em>Click to upload</em>
                  <br><br><br><br>
                  <el-button type="info" @click="showTsvContent">Show example</el-button>
                </div>
                <div class="el-upload__tip" slot="tip">You can only upload tsv files with a maximum size of 500kb</div>
              </el-upload>
            </div>

            <!-- 弹出对话框展示文件内容 -->
            <el-dialog :visible.sync="dialogVisible" title="Show TSV file" width="50%">
              <table class="tsv-table">
                <tr v-for="(row, rowIndex) in tsvAsTable" :key="rowIndex">
                  <td v-for="(cell, cellIndex) in row" :key="cellIndex">{{ cell }}</td>
                </tr>
              </table>
              <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
              </span>
            </el-dialog>
          </el-col>
          </template>

          <el-col :span="filters.method === 'Search by file' ? 20 : 24">
            <el-table
                :data="tableData"
                style="width: 100%;" 
                :row-class-name="tableRowClassName"
                >
                <el-table-column prop="id" label="ID" align="center" sortable></el-table-column>
                <el-table-column prop="chr" label="Chromosome" align="center" sortable></el-table-column>
                <el-table-column prop="posHg19" label="Position (hg19)" align="center" sortable></el-table-column>
                <el-table-column prop="posHg38" label="Position (hg38)" align="center" sortable></el-table-column>
                <el-table-column prop="ref" label="Reference allele" align="center"></el-table-column>
                <el-table-column prop="alt" label="Alternative allele" align="center"></el-table-column>
                <el-table-column prop="score" label="ModVAR score" align="center" sortable></el-table-column>
            </el-table>

            <!-- 分页控件 -->
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, prev, pager, next, jumper"
            >
            </el-pagination>
          </el-col>
        </el-row>
      </div>

      <div v-if="activeLink === '3'" class="github-section">
        <h2>GitHub Repository</h2>
        <a href="https://github.com/kiroro100700/ModVAR" target="_blank" class="github-link">
          <i class="el-icon-link"></i> https://github.com/kiroro100700/ModVAR
        </a>
        <br><br>
      </div>
    </el-main>

    <el-footer>
      <a href="https://github.com/kiroro100700/ModVAR" class="footer-link">
      <i class="el-icon-download"></i>
        Download
      </a>
    </el-footer>
    </el-container>
</template>


<script>
import axios from 'axios';

export default {
  created() {
    this.fetchData();
  },
  data() {
    return {
      images: [
        { id: 1, src: require('@/assets/Fig1.png') },
        { id: 2, src: require('@/assets/Fig2.png') },
        { id: 3, src: require('@/assets/Fig3.png') },
      ],

      loading: false,
      activeLink: '2', // 默认选中的导航项
      dialogVisible: false,     // 控制对话框的显示
      tsvContent: `Chromosome\tPositionHg19\tReferenceAllele\tAlternativeAllele
      1\t57422521\tA\tT
      3\t63600911\tC\tA
      12\t57137871\tC\tT
      X\t86919813\tC\tG`,
      tableData: [],
      methodOptions:["Search by hg19 position","Search by hg38 position","Search by file"],
      total: 13,
      currentPage: 1,
      pageSize: 10,  // 固定每页条数
      chrOptions: [null, "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "X", "Y"],
      alleleOptions: [null, "A", "T", "G", "C"],
      filters: {
        chr: null,
        posHg19: null,
        posHg38: null,
        operator19: 'eq',
        operator38: 'eq',
        ref: null,
        alt: null,
      },
    };
  },
  computed: {
    tsvAsTable() {
      const rows = this.tsvContent.trim().split('\n');
      return rows.map(row => row.split('\t'));
    },
  },
  methods: {
    handleNavSelect(index) {
      this.activeLink = index;
    },
    handleSearchMethodChange() {
      // 清空与上次选择不相关的过滤条件
      this.filters.chr = null;
      this.filters.posHg19 = null;
      this.filters.posHg38 = null;
      this.filters.ref = null;
      this.filters.alt = null;
    },
    setOperator19(operator) {
        this.filters.operator19 = operator; 
    },
    setOperator38(operator) {
        this.filters.operator38 = operator; 
    },
    beforeUpload(file) {
      const maxFileSize = 500 * 1024; // 500KB
      const isTsv = file.name.endsWith('.tsv'); // 校验文件扩展名
      if (!isTsv) {
        this.$message.error("文件格式不正确，仅支持 .tsv 文件");
        return false; // 阻止文件上传
      }
      if (file.size > maxFileSize) {
        this.$message.error("文件大小超过限制，最大500KB");
        return false; // 阻止文件上传
      }
      return true; // 允许文件上传
    },

    showTsvContent() {
      event.stopPropagation(); // 阻止 el-upload 的默认点击行为
      this.dialogVisible = true;
    },

    handleFileUpload(param) {
      this.loading = true; 

      // 显示全屏 loading 动画
      const loadingInstance = this.$loading({
        lock: true,
        text: '文件处理中...',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      const formData = new FormData();
      formData.append('file', param.file); // 将文件添加到表单数据

      // 输出 FormData 内容，检查是否正确附加了文件
      for (let key of formData.keys()) {
        console.log(key, formData.get(key));
      }
      // http://43.153.60.245:8087
      axios.post('http://43.159.142.225:8087/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(response => {
        param.onSuccess(response.data);  
        this.$message.success("Upload Successfully!");

        // 假设返回的是文件的下载链接
        const downloadLink = response.data; // 假设响应中返回的是文件的下载路径
        console.log("Download link:", downloadLink);

        const newWindow = window.open(downloadLink);
        // const newWindow = window.open(downloadLink, '_blank');

        if (newWindow) {
          newWindow.focus(); // 确保新窗口获得焦点
        } else {
          this.$message.error("Unable to open a new tab!Check the browser setting.");
        }

      }).catch(error => {
        if (error.response) {
          const errorMessage = error.response.data || "Upload failed.";  // 获取后端返回的错误信息
          this.$message.error("Upload failed: " + errorMessage);  // 弹出错误消息
        } else {
          this.$message.error("The file upload has failed");  // 网络或其他错误
        }
        param.onError(error);

      }).finally(() => {
        this.loading = false; // 上传完成，关闭loading
        loadingInstance.close();
    });


    },

    fetchData() {
      const loadingInstanceSearch = this.$loading({
        lock: true,
        text: '数据查询中...',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$http.get("/mutation", { 
        params: {
          ...this.filters, 
          page: this.currentPage, 
          pageSize: this.pageSize 
        }
      }).then((response) => {
        this.tableData = response.data.records;
        this.total = response.data.total;
        console.log("Total records:", this.total); // 检查是否为13
      }).catch((error) => {
        console.error("查询数据出错:", error);
        this.$message.error("Fail to query. Please try again later.");
      }).finally(() => {
        // 关闭 loading 动画
        loadingInstanceSearch.close();
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 1 ? "success-row" : "";
    },
  }
};
</script>


<style>
    .el-container {
      display: flex;
      flex-direction: column;
      min-height: 100vh; 
    }

    .video-background {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1; /* 确保视频位于背景 */
    }

    .video-background video {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    .navbar {
      position: fixed; /* 固定定位 */
      top: 0;         /* 距顶部0 */
      right: 0;       /* 距右侧0 */
      width: auto;    /* 宽度根据内容调整 */
      z-index: 1000;  /* 确保在页面最顶层 */
      background-color: transparent; /* 透明背景 */
      display: flex;
      justify-content: flex-end;
      padding: 10px;
    }

    .el-main {
      flex-grow: 1;
      background-color: #E9EEF3;
      color: #333;
      text-align: center;
      padding: 50px 180px !important;
      background-image: url('../assets/bgfooter.png'); 
      background-size: cover;     
      background-position: right; 
      background-repeat: no-repeat; 
    }

    .el-header{
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;
      box-sizing: border-box;
      padding: 0 0 0 0 !important;
    }

    .el-footer {
      background-color: #007DBC;
      color: #333;
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }


    .el-menu {
      width: 100%;
      min-height: 60px;
      /* background-color: #007DBC !important; */
      background-color: transparent  !important;
      align-items: center; /* 垂直方向居中 */
      border-bottom: none !important;
      padding: 0 0;
      display: flex;
      justify-content: flex-end;
    }


    .el-menu-item {
      width: 100px;
      max-height: 60px;
      color: white !important;
      font-weight: bold;
      justify-content: center;
      font-size: 20px !important;
      align-items: center !important; /* 垂直方向居中 */
    }

    .el-menu-item:hover {
      background-color: #36aaf3 !important; 
    }

    .el-menu-item.is-active {
      background-color: #36aaf3 !important; /* 选中时的背景色 */
      color: white !important;             /* 选中时的文字颜色 */
      font-weight: bold;                   /* 可选：加粗选中文字 */
    }


    .el-header{
      height: 270px !important; 
      /* background-image: url('../assets/bgheader.png');  */
      /* background-size: cover;   
      background-position: right; 
      background-repeat: no-repeat;  */
    }

    .header-title h1 {
      font-size: 65px; 
      color: white;
      margin-top: 5px;
    }

    .header-subtitle {
      font-size: 20px;
      color: white;
      font-weight: bold;
      margin-top: -50px;
    }

    .search-title {
      width: 100%;
      height: 30px;
      line-height: 30px;
      background-color: #007DBC;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      font-size: 15px;
      padding: 10px 0;
      border-radius: 4px 4px 0 0;
    }
    
    .search-container {
      height: 50px; /* 搜索栏占位高度 */
      display: flex;
      align-items: center;
      justify-content: center;
      transition: height 0.3s ease; /* 添加过渡效果 */
    }

    .search-container:not(.show-search) {
      height: 0; /* 隐藏时高度为0 */
      overflow: hidden; /* 隐藏内容 */
    }

    .el-form{
      margin-top: 35px !important; 
    }

    .el-form-item {
      width: 200px !important;
    }

    .el-form-item.search{
      width: 80px !important;
    }


    .upload_contrainer{
      width: 85%;
    }

    .el-upload {
      width: 100% !important;
      height: 300px !important;
    }

    .el-upload-dragger {
      width: 100% !important;
      height: 300px  !important;
    }

    .tsv-table {
      width: 100%;
      border-collapse: collapse;
      font-family: monospace;
    }

    .tsv-table td {
      padding: 4px 8px;
      border: 1px solid #ddd;
      text-align: left;
    }

    .el-card__body, .el-main {
      padding: 50px 200px !important;
    }

    .el-table .success-row {
      background: #e3e8ee;
    }
  
    .el-table th.el-table__cell {
      background-color: #007DBC !important;
    }

    .el-table__header-wrapper th {
      font-size: 15px; 
      height: 30px;  /*表格首行高度*/
      line-height: 30px;
      color: white;
    }

    .el-table .el-table__cell {
      padding: 7.5px 0 !important; /* 控制行高 */
    }

    .el-pagination {
      margin-top: 20px; 
    }

    .footer-link {
      text-decoration: none;
      color: white;
      font-weight: bold;
    }

    .el-carousel__container {
      margin-top:20px;
      position: relative;
      width: 90%; 
      padding-top: 56.25%; 
      overflow: hidden; 
    }

    .el-carousel__item {
      overflow: visible !important;
    }
    .el-image{
      width: 100% !important;
    }

    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 150px;
      margin: 0;
    }

    .el-carousel__item:nth-child(n) {
      /* background-color: #99a9bf; */
      background-color: #EFF3F7;
    }

    .enhanced-text {
      background: #f8f8fa;
      padding: 20px;       
      border-radius: 15px; 
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      font-family: "Arial", sans-serif;
      color: #333333f1; 
    }

    .enhanced-text h2 {
      font-size: 20px; 
      color: #007dbc;   
      margin-bottom: 10px;
    }

    .enhanced-text p {
      line-height: 1.8;  
      margin-bottom: 15px; 
    }

    .enhanced-text strong {
      color: #007dbc;  
      font-weight: bold; 
    }

    .github-section {
      text-align: center;
      padding: 20px;
      background-color: #f5f7fa; /* 淡灰背景色 */
      border-radius: 10px; /* 添加圆角 */
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
      margin: 20px auto;
      max-width: 600px; /* 限制宽度 */
    }

    .github-section h2 {
      font-size: 22px;
      color: #333;
      margin-bottom: 10px;
    }

    .github-link {
      font-size: 18px;
      color: #007DBC;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 5px; /* 图标和文字间距 */
    }

    .github-link:hover {
      color: #005b8f; /* 鼠标悬浮时的颜色 */
      text-decoration: underline; /* 鼠标悬浮时的下划线 */
    }
    
</style>